import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TextArea from '../ui/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { checkValidate, onCloseModal, setFromInfo } from '../../features/checkout/checkoutSlice';
import { useAddOrderMutation, useAddOrderOnlineMutation } from '../../features/api/apiSlice';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { toast } from 'react-toastify';
// import { setCartEmty } from '../../features/cartProducts/cartSlice';
import serverurl from '../../utils/ServerUrl';

const Cart = ({ orderSmr }) => {
    const { notes, items, subtotal, delivery, CouponDiscount, GrandTotal, paymentStatus, invoice, deliverDifAddress, checkInputValidate, coupon } = useSelector((state) => state.checkout);
    const { userInfo } = useSelector((state) => state.user);
    const [addOrder, { data: product, isError, isSuccess, isLoading }] = useAddOrderMutation(); // redux || add new product :) ->
    const [addOrderOnline, { }] = useAddOrderOnlineMutation(); // redux || add new product :) ->

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [loadingForOrderRes, setLoadingForOrderRes] = useState(false);

    const setDataToState = (name, data) => {
        dispatch(setFromInfo({ 'name': name, 'data': data }))
    };

    const productIds = items.map(item => ({ id: item._id, quantity: item.quantity, total: item.total, img: item.cardImg, name: item.name, price: item.price }))

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    var today = new Date();
    var time = formatAMPM(today);
    var date = today.getDate() + ' ' + monthNames[today.getMonth()] + ' ' + today.getFullYear();
    const timeAndDate = date + " " + time;

    // ================
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const newDate = today.addDays(6);
    let dd = String(newDate.getDate()).padStart(2, '0');
    // let mm = String(newDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = newDate.getFullYear();
    const deliveryExpectedDate = dd + ' ' + monthNames[newDate.getMonth()] + ' ' + yyyy;
    // console.log(deliveryExpectedDate)

    // ===========================

    const submitOrder = () => {
        if (items?.length > 0) {
            dispatch(checkValidate());
        }
        else {
            toast.error("cart is empty !!", {
                position: "bottom-left",
            });
        }
    }

    const confurmOrder = () => {
        setLoadingForOrderRes(true)
        if (paymentStatus === "paid") {
            //     addOrderOnline({
            //     itemIds: productIds,
            //     userId: userInfo?.uid,
            //     totalPrice: GrandTotal,
            //     contactInfo: { phone: invoice.mobile, email: invoice.email },
            //     deliveryAddress: invoice,
            //     deliverDifAddress: deliverDifAddress,
            //     paymentStatus: paymentStatus,
            //     PlacedDate: timeAndDate,
            //     deliveryExpectedDate: deliveryExpectedDate
            // })
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    itemIds: productIds,
                    userId: userInfo?.uid,
                    totalPrice: GrandTotal,
                    contactInfo: { phone: invoice.mobile, email: invoice.email },
                    deliveryAddress: invoice,
                    deliverDifAddress: deliverDifAddress,
                    paymentStatus: paymentStatus,
                    PlacedDate: timeAndDate,
                    deliveryExpectedDate: deliveryExpectedDate,
                    notes: notes,
                    usedCoupon: coupon?.persent ? coupon : {}
                })
            };

            fetch(`${serverurl}/init`, requestOptions)
                .then(response => response.json()).then((res) => {
                    window.location.replace(res);
                    setLoadingForOrderRes(false)
                })
                .catch((err) => {
                    console.log(err.message)
                });

            dispatch(onCloseModal(false))

        } else {

            addOrder({
                itemIds: productIds,
                userId: userInfo?.uid,
                totalPrice: GrandTotal,
                contactInfo: { phone: invoice.mobile, email: invoice.email },
                deliveryAddress: invoice,
                deliverDifAddress: deliverDifAddress,
                paymentStatus: paymentStatus,
                PlacedDate: timeAndDate,
                deliveryExpectedDate: deliveryExpectedDate,
                notes: notes,
                usedCoupon: coupon?.persent ? coupon : {}
            })

            dispatch(onCloseModal(false))
        }



    }

    useEffect(() => {
        if (product) {
            setLoadingForOrderRes(false)
            navigate("/order/summary");
            sessionStorage.setItem('success', JSON.stringify(product));
            // dispatch(setCartEmty())
        }
    }, [product, isError, isSuccess, navigate, setLoadingForOrderRes]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: 'border-radius: 30px;',
        boxShadow: 24,
        p: 2,
    };
    const handleClose = () => {
        dispatch(onCloseModal(false))
    };


    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);


    return (
        <div>
            <div>
                <table className="table-auto w-full">
                    <thead>
                        <tr className='border-b-2'>
                            <th className='w-28 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 sm:block hidden '></th>
                            <th className='w-48 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>{translate ? "product" : "পণ্য"}</th>
                            <th className='w-24 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>{translate ? "quantity" : "পরিমাণ"}</th>
                            <th className='w-20 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600 md:block hidden'>{translate ? "price" : "মূল্য"}</th>
                            <th className='w-20 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 text-end'>{translate ? "total" : "মোট"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.length > 0 ?
                            items.map((item, i) => (
                                <tr key={i} className='border-b'>
                                    <td className='sm:block hidden '>
                                        <img className='h-16 m-2 object-contain' src={item.cardImg} alt="" />
                                    </td>
                                    <td className='text-gray-600 py-3 px-2'>{item.name.length > 32 ? (item.name.substring(32, 0) + "..") : item.name}</td>
                                    <td className='text-center p-3'>{item.quantity}</td>
                                    <td className='md:block hidden text-center relative -top-8'>{item.price}</td>
                                    <td className='text-end py-3 pr-3'>{item.total}</td>
                                </tr>
                            ))
                            :
                            <div className='p-3 text-center w-full'>
                                <h3 className='text-center w-full'>{translate ? "Empty" : "খালি"} 😊</h3>
                            </div>
                        }

                    </tbody>
                </table>
                <table className='w-full'>
                    <thead className='w-full'>
                        <tr>
                            <th className=' py-2.5 px-3 w-3/4 font-semibold font-poppins text-sm text-gray-600'>{translate ? "Subtotal" : "উপ মোট"}</th>
                            <th className=' py-2.5 px-3 text-right w-1/4 font-normal font-poppins text-md text-gray-600 whitespace-nowrap'>{subtotal} {translate ? "BDT" : "টাকা"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* <tr className='border-b'>
                            <td className='py-2.5 px-3  font-semibold font-poppins text-sm text-gray-600'>Tax (0%)</td>
                            <td className='text-right py-2.5 px-3  font-normal font-poppins text-md text-gray-600 whitespace-nowrap'>0.000 BDT</td>
                        </tr> */}
                        {/* <tr className='border-b'>
                            <td className='py-2.5 px-3  font-semibold font-poppins text-sm text-gray-600'>Delivery <span className='f font-normal'>(Delivery Within 2 Days)</span></td>
                            <td className='text-right py-2.5 px-3  font-normal font-poppins text-md text-gray-600 whitespace-nowrap'>0.000 BDT</td>
                        </tr> */}
                        <tr className='border-b'>
                            <td className='py-2.5 px-3  font-semibold font-poppins text-sm text-gray-600'> {translate ? "Delivery Fees" : "ডেলিভারি ফি"}</td>
                            <td className='text-right py-2.5 px-3  font-normal font-poppins text-md text-gray-600 whitespace-nowrap'>{delivery} {translate ? "BDT" : "টাকা"}</td>
                        </tr>
                        <tr className='border-b'>
                            <td className='py-2.5 px-3  font-semibold font-poppins text-sm text-gray-600'>{translate ? "Coupon Discount" : "কুপন ডিসকাউন্ট"}</td>
                            <td className='text-right py-2.5 px-3  font-normal font-poppins text-md text-gray-600 whitespace-nowrap'>{CouponDiscount} {translate ? "BDT" : "টাকা"}</td>
                        </tr>
                        <tr className=''>
                            <td className='py-2.5 px-3  font-semibold font-poppins text-sm text-gray-600'>{translate ? "Grand Total" : "সর্বমোট"}</td>
                            <td className='text-right py-2.5 px-3  font-normal font-poppins text-base text-gray-600 whitespace-nowrap'>{GrandTotal} {translate ? "BDT" : "টাকা"}</td>
                        </tr>

                    </tbody>
                </table>
                {!orderSmr &&
                    <div className='py-2'>
                        <TextArea
                            title={translate ? "Notes" : "মন্তব্য"}
                            className="p-2 text-md font-poppins"
                            onBlur={(e) => setDataToState('notes', e.target.value)}
                            placeholder={translate ? "Note About The Order, For Example: ANote For The Delivery Of The Order" : "অর্ডার সম্পর্কে নোট, উদাহরণ স্বরূপ: অর্ডার ডেলিভারির জন্য নোট"}
                        />

                        <div className='py-3 flex justify-center gap-1'>
                            <Link to="/">
                                <button className='b bg-gray-500 px-3 py-2 focus:outline-none rounded font-normal text-white'>{translate ? "Continue Shopping" : "কেনাকাটা চালিয়ে যান"}</button>
                            </Link>
                            {isLoading || loadingForOrderRes ?
                                <button className='bg-bnd-1 px-3 py-2 focus:outline-none rounded font-normal text-white cursor-wait'>{translate ? "Loading..." : "লোড হচ্ছে ..."}</button>
                                :
                                <button onClick={submitOrder} className='bg-bnd-1 px-3 py-2 focus:outline-none rounded font-normal text-white'>{translate ? "Place Your Order" : "তোমার অর্ডার দাও"}</button>
                            }
                        </div>
                    </div>
                }
            </div>
            <Modal
                open={checkInputValidate}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h2 className='text-xl font-poppins pb-5'>
                        {translate ? "Do you want to place an order?" : "আপনি অর্ডার টি নিশ্চিত করতে চান?"}
                    </h2>
                    <div className="flex gap-2">
                        <div className="w-full">
                            <button onClick={handleClose} type="button" className="w-full text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">{translate ? "Cancel" : "বাতিল করুন"}</button>
                        </div>
                        <div className="w-full">
                            <button onClick={confurmOrder} type="button" className="w-full text-white bg-purple-700 hover:bg-purple-800 focus:outline-none focus:ring-4 focus:ring-purple-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900">{translate ? "confirm" : "নিশ্চিত করুন"}</button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default Cart;